export default __webpack_public_path__ + "static/sample_cd_front-8d3c54660d013b62e6ff43f3e95dfe36.jpg";